import Backbone from 'backbone'

const DateFrom = Backbone.Model.extend({
    defaults: {
        milliseconds: 1,
    },
})

export default DateFrom